export enum EZone {

    Berge = 1,
    IntermediaireAccessible = 2,
    IntermediaireNonAccessible = 3,
    Profonde = 4,
}